// extracted by mini-css-extract-plugin
export default {"tooltip":"FinishEditingSectionButtonTooltip_tooltip__KyeII"};